const logo = {
  jakartalabsRed: require("../assets/logo/jakartalabs-red.png").default,
  jakartalabs: require("../assets/logo/jakartalabs.png").default,
  partner1: require("../assets/logo/partner-1.png").default,
  partner2: require("../assets/logo/partner-2.png").default,
  partner3: require("../assets/logo/partner-3.png").default,
};

export default logo;
